import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  row-gap: 20px;
`;

export const Description = styled.div`
  width: 100%;
  color: ${({ theme }) => theme.colors.greys.darker};
  font: ${({ theme }) => theme.fonts.textBigHeight24};
  text-align: left;
  white-space: pre-line;
`;

export const ErrorText = styled.div`
  color: ${(props) => props.theme?.colors?.infoRed};
  font: ${(props) => props.theme.fonts?.textSmallHeight14Weight600};
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  row-gap: 8px;
`;
